import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "task-summary-list" }

import { ref, onMounted, computed, nextTick } from 'vue';
import { storeToRefs } from 'pinia';

import {
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  BaseButton,
  BaseIcon,
  useCreateModal,
  BaseSwitch
} from 'xrk-components';
import { Setting } from '@element-plus/icons-vue';

import {
  BizTableSetField,
  useSetTableConfig
} from '@/components/biz/biz-table-set-field/index';
import { summaryList, exportRecordSummaryList } from '../data-source/apis';
import { createTable } from '../hooks/useCreatTable';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import appStore from '@/store';
import { getUnqualifiedRowConfig } from '@/utils/unqualified';

const storeKey = 'task-summary-list';

export default /*#__PURE__*/_defineComponent({
  __name: 'task-summary-list',
  setup(__props) {

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
const updateKey = ref(1);

const xrkTableRef = ref<XrkTableRef>();

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: []
});
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [],
  baseConfig: {
    rowClassName({ row, rowIndex }) {
      return getUnqualifiedRowConfig({
        row: row,
        rowIndex: rowIndex,
        isNotUnqualified: row?.superviseStatus === 1
      });
    }
  }
});
const baseSearchColumns = ref([]);
const baseTableColumns = ref([]);
const isCurrentTerm = ref('0');

// 工业-1 服务商-2 供应商-3
const { defaultUserFnCode } = storeToRefs(appStore.useUserStoreSetup);
/**
 * 是否是服务商
 */
const isAsp = computed(() => defaultUserFnCode.value === 2);
/**
 * 是否是供应商
 */
const isSupplier = computed(() => defaultUserFnCode.value === 3);

/**
 * @description: 设置字段操作逻辑
 * @returns {*}
 */
const onSettingsClick = () => {
  useCreateModal(BizTableSetField, {
    tableColumns: baseTableColumns.value,
    searchColumns: baseSearchColumns.value,
    storeKey: storeKey,
    onSuccess: ({ newTableColumns, newSearchColumns }) => {
      searchConfig.value.searchColumns = newSearchColumns;
      tableConfig.value.tableColumns = newTableColumns;
      updateKey.value += 1;
      nextTick(() => {
        onRefreshTable();
      });
    }
  });
};

const onRefreshTable = () => {
  xrkTableRef.value?.initCurrentList();
};

//是否是个体
const isGeti = computed(() => {
  return projectInfo.value.ctype === 3;
});
const setTable = async () => {
  const { searchColumns, tableColumns } = await createTable(
    isGeti,
    projectInfo.value.id,
    isSupplier,
    isAsp,
    projectInfo.value.sceneType
  );

  baseSearchColumns.value = searchColumns;
  baseTableColumns.value = [...tableColumns];

  // 回显设置字段逻辑
  const { newTableColumns, newSearchColumns } = useSetTableConfig({
    storeKey: storeKey,
    tableColumns: baseTableColumns.value,
    searchColumns: baseSearchColumns.value
  });

  searchConfig.value = {
    searchColumns: newSearchColumns,
    otherComponents: [
      {
        render: () => {
          return (
            <>
              <BaseButton
                v-resource={[['任务汇总_导出']]}
                type="primary2"
                click={async () => {
                  await exportRecordSummaryList({
                    req: {
                      ...xrkTableRef.value.getSearchValue(),
                      isCurrentTerm
                    },
                    selectedFieldNames: tableConfig.value.tableColumns
                      .map(item => item.prop)
                      .filter(Boolean) as string[],
                    sceneType: projectInfo.value.sceneType,
                    projectId: projectInfo.value.id
                  });
                }}
              >
                导出
              </BaseButton>
            </>
          );
        }
      },
      {
        fixed: 'right',
        render: () => {
          return (
            <>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  margin: 8px 0;
                "
              >
                <span style="font-size: 14px; height: 22px">往期人员：</span>
                <BaseSwitch
                  style="margin-right: 10px"
                  active-text="显示"
                  inactive-text="不显示"
                  active-value="0"
                  inactive-value="1"
                  v-model={isCurrentTerm}
                  onChange={onRefreshTable}
                ></BaseSwitch>
                <BaseIcon>
                  <Setting />
                </BaseIcon>
                <span
                  style="
                    font-size: 14px;
                    color: #4c4c4c;
                    line-height: 22px;
                    margin-left: 2px;
                    cursor: pointer;
                  "
                  onClick={onSettingsClick}
                >
                  设置字段
                </span>
              </div>
            </>
          );
        }
      }
    ]
  };
  tableConfig.value = {
    ...tableConfig.value,
    tableColumns: newTableColumns
  };
  updateKey.value += 1;
  nextTick(() => {
    onRefreshTable();
  });
};

onMounted(() => {
  setTable();
});

const getListAjax = async params => {
  const reqParams = {
    ...params,
    sceneType: projectInfo.value.sceneType,
    projectId: projectInfo.value.id,
    isCurrentTerm: isCurrentTerm.value
  };
  return await summaryList(reqParams);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_unref(XrkTable), {
      style: {"height":"650px"},
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      key: updateKey.value,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value,
      requestNow: false
    }, null, 8, ["searchConfig", "tableConfig"]))
  ]))
}
}

})